export class DocumentModel {
  constructor(documentModel: DocumentModel = null) {
    if (documentModel != null) {
      this.TempId = documentModel.TempId;
      this.RealId = documentModel.RealId;
      this.Name = documentModel.Name;
      this.mimeType = documentModel.mimeType;
      this.extension = documentModel.extension;
      this.RequestId = documentModel.RequestId;
      this.Size = documentModel.Size;
      this.IsDeleted = documentModel.IsDeleted;
      this.SizeToShow = documentModel.SizeToShow;
      this.isHideDownload = true;
    }
  }
  TempId?: string;
  RealId?: string;
  Name: string;
  mimeType: string;
  extension: string;
  RequestId?: string;
  Size: number;
  IsDeleted?: boolean;
  SizeToShow: string;
  isHideDownload?: boolean;
}
